//el选择框滑动到底部自动刷新
const el_select_loadmore = {
  inserted(el, binding) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector(
      ".el-select-dropdown .el-select-dropdown__wrap"
    );
    let fun = () => {
      const { scrollTop, clientHeight, scrollHeight } = SELECTWRAP_DOM;
      if (scrollHeight - scrollTop <= clientHeight + 10) {
        if (typeof binding.value == "function") {
          if (!binding.timeBefore) {
            binding.timeBefore = new Date().getTime();
            binding.value();
          } else {
            let timeNow = new Date().getTime();
            if (timeNow - binding.timeBefore > 100) {
              binding.timeBefore = timeNow;
              binding.value();
            }
          }
        }
      }
    };
    //防抖
    let fun2 = () => {
      if (binding.xbEvent) {
        clearTimeout(binding.xbEvent);
      }
      binding.xbEvent = setTimeout(fun, 50);
    };
    SELECTWRAP_DOM.addEventListener("scroll", fun2);
  },
};
export { el_select_loadmore };
